"use client";
import { Button } from "@/components/ui/button";
import { signIn } from "next-auth/react";
import { FaGoogle } from "react-icons/fa";

export default function SignInProviders() {
	const handleGoogleSignIn = () => {
		signIn("google");
	};

	return (
		<>
			<Button
				variant="outline"
				className="w-full"
				onClick={handleGoogleSignIn}
			>
				<FaGoogle className="mr-2 h-5 w-5" />
				Google ile Giriş Yap
			</Button>
		</>
	);
}
